import React from 'react';
import { Pagination, Table } from "antd"


export const MYCTable = ({ load, loading, pageNo, totalCount, pageSize, name, cols, list: data }) => {
    const getRowKey = (record, index) =>
        record?.id ||
        record?.uid ||
        record?.key ||
        record?.createdAt ||
        record?.updatedAt ||
        `${name || 'row'}-${index}`;

    return <Table
        columns={cols}
        rowKey={getRowKey}
        pagination={{
            pageSize: pageSize,
            current: pageNo,
            total: totalCount,
            onChange: (pageNo, pageSize) => {
                load(pageNo, pageSize);
            }
        }
        }
        loading={loading}
        dataSource={data}
        style={{ width: '100%' }}
    />
}

export const MYCPagination = ({ load, pageNo, totalCount, pageSize, }) => pageSize && <Pagination
    pageSize={pageSize}
    current={pageNo}
    total={totalCount}
    onChange={(pageNo, pageSize) => {
        load(pageNo, pageSize);
    }}
/>
